import { FastForward, Scissors } from "lucide-react";
import { ChipGroup, Section } from "@/components/yarn/Field";
import { THEMES } from "@/lib/api";

const ACTIVE = ["writing", "voting", "results"];
const secs = (list) => list.map((n) => ({ value: n, label: `${n}s` }));

export function HostControls({ room, send }) {
  const active = ACTIVE.includes(room.phase);
  return (
    <div className="patch p-5 space-y-5" data-testid="host-controls">
      <p className="font-display text-sm uppercase tracking-widest text-[var(--yarn-muted)]">Host tools</p>
      {active && (
        <div className="grid grid-cols-2 gap-2">
          <button className="btn-soft h-11 text-sm inline-flex items-center justify-center gap-1.5" onClick={() => send("skip")} data-testid="host-skip-button">
            <FastForward size={15} /> Skip timer
          </button>
          <button className="btn-soft h-11 text-sm inline-flex items-center justify-center gap-1.5 text-red-700" onClick={() => send("end")} data-testid="host-end-story-button">
            <Scissors size={15} /> End story
          </button>
        </div>
      )}
      <Section label="Theme for the next story">
        <ChipGroup options={THEMES.map((t) => ({ value: t.key, label: t.label }))} value={room.theme}
          onChange={(v) => send("settings", { theme: v })} testid="host-theme" />
      </Section>
      <Section label="Seconds to write">
        <ChipGroup options={secs([30, 45, 60, 90, 120])} value={room.round_seconds} onChange={(v) => send("settings", { round_seconds: v })} testid="host-round-seconds" />
      </Section>
      <Section label="Seconds to vote">
        <ChipGroup options={secs([20, 30, 45, 60])} value={room.vote_seconds} onChange={(v) => send("settings", { vote_seconds: v })} testid="host-vote-seconds" />
      </Section>
      {room.banned.length > 0 && (
        <Section label="Banned players">
          <ul className="space-y-2" data-testid="banned-list">
            {room.banned.map((b) => (
              <li key={b.id} className="flex items-center justify-between gap-2">
                <span className="font-display text-sm">{b.username}</span>
                <button className="btn-soft h-9 px-3 text-xs" onClick={() => send("unban", { user_id: b.id })} data-testid={`unban-${b.username}`}>Unban</button>
              </li>
            ))}
          </ul>
        </Section>
      )}
    </div>
  );
}
